/* eslint-disable no-console */
import _ from 'lodash';
import qs from 'qs';
import axios from '../axios/index';

const GetRequest = (queryName) => {
  const query = decodeURI(window.location.search.substring(1));
  const vars = query.split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === queryName) {
      return pair[1];
    }
  }
  return null;
};

const getCookie = (name) => {
  let arr;
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  if (document.cookie.match(reg)) {
    arr = document.cookie.match(reg);
    return unescape(arr[2]);
  }
  return null;
};

const setCookie = (name, value, Days) => {
  const exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  // console.log(`setCookie前，${name} =${document.cookie}.`)
  // console.log(`${name}=${escape(value)};expires=${exp.toGMTString()}`)
  document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/`;
  // console.log(`setCookie后，${name} =${document.cookie}.`)
};

// const clearAllCookie = () => {
//   let date = new Date()
//   date.setTime(date.getTime() - 2 * 24 * 60 * 60 * 1000)
//   const keys = document.cookie.match(/[^ =;]+(?=\=)/g)
//   // console.log(`需要删除的cookie名字：${keys}`)
//   if (keys) {
//     // eslint-disable-next-line no-plusplus
//     for (let i = keys.length; i--; )
//       document.cookie = `${keys[i]}=null;expire=${date.toGMTString()};path=/`
//   }
// }

export const getNoNullObj = (obj, excludeZero = false) => {
  const newObj = obj;
  Object.keys(newObj).forEach((key) => {
    if (newObj[key] instanceof Object) {
      getNoNullObj(newObj[key]);
    }
    if (newObj[key] == null || newObj[key] === '' || (excludeZero && Number(newObj[key]) === 0)) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const checkResponse = (res) => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data);
    } else {
      reject(res.statusText);
    }
  });
};

export const checkResponseErr = (err) => {
  const msg = _.get(err, 'response.data.message', '系统错误');
  return Promise.reject(msg);
};

export const getCompanyId = () => {
  console.log(getCookie('companyid') || 999, 'fromcookie');
  return getCookie('companyid') || qs.parse(document.location.search.split('?')[1]).companyid;
};
export const getCompanyIdFromCookie = () => {
  return getCookie('companyid');
};
export const clearCompanyId = () => {
  setCookie('companyid', '', -1);
};
export const saveCompanyId = (expireDay = 7, pCompanyId = null) => {
  let companyId = pCompanyId;
  if (!companyId) {
    clearCompanyId();
    companyId = qs.parse(document.location.search.split('?')[1]).companyid;
    if (companyId === 0) {
      // 个人登录
      localStorage.setItem('isPersonal', true);
    } else {
      // 企业登录
      localStorage.setItem('isPersonal', false);
    }
  }
  if (companyId || companyId === 0) {
    console.log(companyId, 'savecompanyId');
    setCookie('companyid', companyId, expireDay);
  } else {
    clearCompanyId();
  }
};

export const saveToken = (expireDay = 7, pToken = null) => {
  let token = pToken;
  if (!token) {
    token = GetRequest('token');
  }
  if (token) {
    setCookie('token', token, expireDay);
  }
};

export const getToken = () => {
  return qs.parse(document.location.search.split('?')[1]).token || getCookie('token');
};

export const setSpecialKeys = (datas) => {
  if (datas) {
    console.log(typeof datas);
    localStorage.setItem('specialKeys', JSON.stringify(datas));
  }
};

export const getSpecialKeys = (key) => {
  const specialKeys = localStorage.getItem('specialKeys');
  if (key) {
    return specialKeys ? JSON.parse(specialKeys)[key] || {} : {};
  }
  return specialKeys ? JSON.parse(specialKeys) : [];
};

export const clearSpecialKeys = () => {
  if (localStorage.getItem('specialKeys')) {
    localStorage.removeItem('specialKeys');
  }
};

export const getSpecial = () => {
  return localStorage.getItem('isSpecial') || false;
};

export const clearSpecialFlag = () => {
  if (localStorage.getItem('isSpecial')) {
    localStorage.removeItem('isSpecial');
  }
};
export const clearSpecial = () => {
  if (localStorage.getItem('isSpecial')) {
    localStorage.removeItem('isSpecial');
  }
};
export const clearToken = () => {
  console.log('清除token');
  setCookie('token', '', -1);
  setCookie('companyid', '', -1);
  clearSpecialKeys();
  clearSpecial();
};
export const getTokenFromUrl = () => {
  return qs.parse(document.location.search.split('?')[1]).token;
};
export const getCompanyIdFromUrl = () => {
  return qs.parse(document.location.search.split('?')[1]).companyid;
};
export const needRefreshCompanyId = () => {
  return getCompanyIdFromUrl() !== getCompanyIdFromCookie();
};
export const refreshCompanyId = (id) => {
  if (id) {
    saveCompanyId(7, id);
  } else {
    if (needRefreshCompanyId()) {
      console.log('need--save');
      clearSpecialKeys();
      saveCompanyId();
    }
    if (!getCompanyIdFromCookie()) {
      console.log('need--save');
      saveCompanyId();
    }
  }
};

export const saveUseEnv = (env = 'next', expireDay = 1095) => {
  setCookie('useenv', env, expireDay);
};

export const getUseEnv = () => {
  return getCookie('useenv');
};

export const isGrayUser = () => {
  const env = getUseEnv();
  return env === 'next';
};

export const getProjectId = () => {
  let projectId = null;
  const reg = new RegExp(/\/projects\/(\d+)\/.*/);
  const res = window.location.href.match(reg);
  projectId = (res && res.length > 0 && res[1]) || null;
  if (projectId == null) {
    const query = qs.parse(document.location.search.replace('?', ''));
    return query.projectId || '';
  }
  return projectId;
};

// export const getPermission = (projectId) => {
//   const currentProjectId = projectId || getProjectId()
//   if (currentProjectId) {
//     return axios.get(`/api/v1/projects/${currentProjectId}/users/permissions`).then(({ data }) => { return data.data })
//   }
//   return Promise.resolve()
// }

export const getPermission = (projectId) => {
  const currentProjectId = projectId || getProjectId();
  const permissions = JSON.parse(sessionStorage.getItem('jtkPermission') || '{}');
  const fetchPermFromRemote = () => {
    return axios
      .get(`/api/v1/projects/${currentProjectId}/config/permissions`)
      .then(checkResponse)
      .then((data) => {
        sessionStorage.setItem('jtkPermission', JSON.stringify(data));
        return data;
      });
  };
  const fetchIsValid = () => {
    return axios
      .get(`/api/v1/projects/${currentProjectId}/config/permissions/valid`)
      .then(checkResponse);
  };

  if (Object.keys(permissions).length === 0) {
    return fetchPermFromRemote();
  }

  return fetchIsValid().then((data) => {
    if (data) {
      return Promise.resolve(permissions);
    }
    return fetchPermFromRemote();
  });
};

export const getDygcApiPrefix = (isProd = false) => {
  return isProd ? '/api/v3' : '/api/v2';
};
export const isJcbUser = () => {
  return getToken() && getToken().length <= 128;
};
